import { useStationLabelStore } from '../store/useStationLabelStore'

// Popisek stanice pro nabídku dotažení dat (FillPromptDialog, IncompleteDataBadge).
// Respektuje globální volbu „Popisek stanice" (useStationLabelStore.labelFields):
// ID / Název / Plný název / Upřesnění, příp. kombinaci — spojené " · " na jeden řádek.
// Fallback na gh_id, když nic nevybráno nebo pole prázdná.
export function stationInlineLabel(station, ghId, labelFields) {
  const fields = labelFields?.length ? labelFields : ['name']
  const parts = fields.map((k) => station?.[k]).filter(Boolean)
  return parts.length ? parts.join(' · ') : (station?.name ?? ghId)
}

// Hook varianta — vezme labelFields z globálního storu.
export function useStationInlineLabel() {
  const labelFields = useStationLabelStore((s) => s.labelFields)
  return (station, ghId) => stationInlineLabel(station, ghId, labelFields)
}
